import RebrandingProvider from './RebrandingProvider'

export default RebrandingProvider
